import React, {useMemo, useState} from "react";
import {Button, Space, Typography} from "antd";
import {useTranslate} from "../../../../hooks/translate.hook";
import {ReportsAccountingMonthlyStatementsUploadModal} from "./upload-modal/upload-modal";
import {ColumnsType} from "antd/es/table";
import i18n from "i18next";
import {columnsFactory} from "./statements-list.columns";
import {filterGroupsFactory} from "./statements-list.filter-groups";
import FilteredTable from "../../../common/filtered-table/filtered.table";
import {ComponentPropsFromRoute} from "../../../../routers/routers";
import {DailyStatement} from "../../../../models/accounting/daily-statements";
import {ColumnsConfig, convertTableColumnsToColumnConfigs} from "../../../../utils/table";
import {FilterDataHandler} from "../../../../models/filter/filter.data.handler";
import {FieldGroupConfig} from "../../../../models/filter/filter.group";
import {dailyStatementService} from "../../../../services/accounting/daily-statement.service";

export enum FilterButtonsTypes {
    LAST = "okay",
    ARCHIVE = "archive"
}

export const AccountingDailyStatements: React.FC<ComponentPropsFromRoute> = ({name}) => {
    const t = useTranslate();

    const columns: ColumnsType<DailyStatement> = useMemo(() => columnsFactory(t), [i18n.language]);
    const columnsConfigs: ColumnsConfig = useMemo(() => convertTableColumnsToColumnConfigs<DailyStatement>(columns), [i18n.language])
    const dataHandler: FilterDataHandler<DailyStatement> = useMemo(() => new FilterDataHandler(request => dailyStatementService.getAll(request)), []);
    const fcgConfigs: FieldGroupConfig[] = useMemo(() => filterGroupsFactory(t), []);
    const [uploadModalShown, setUploadModalShown] = useState<boolean>(false);

    return <Space direction="vertical" size={[20, 20]}>
        <Typography.Title level={3} style={{margin: 0}}>
            {t("ACCOUNTING.DAILY-STATEMENTS.TITLE")}
        </Typography.Title>
        <Button onClick={() => setUploadModalShown(true)} type={"primary"}>
            {t("REPORTS.ACCOUNTING.MONTHLY-STATEMENTS.UPLOAD.TITLE")}
        </Button>
        <ReportsAccountingMonthlyStatementsUploadModal
            visible={uploadModalShown}
            onClose={() => setUploadModalShown(false)}
            onSubmit={() => true}
        />
        <FilteredTable
            columns={columns}
            columnsConfigs={{columns: columnsConfigs, pageKey: name}}
            dataHandler={dataHandler}
            filterGroups={fcgConfigs}
        />
    </Space>;
}